export default "https://cdn-static.gokick.com/assets/cf07e8c5970f78b6a967654f4a6b4453caa2db11/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";